import bean from "../../assets/images/beian.png"
import styles from "./index.module.scss"

const HhxFooter = () => {
    return (
        <div className={styles.pcBottom}>
            <div className="container">
                <div className={styles.copyRight}>
                    <div className={styles.footer}>
                        <p>
                            地址：重庆市两江新区礼嘉街道礼慈路37号
                        </p>
                        <p>
                            <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">
                                渝 ICP 备 20005691 号 - 2
                            </a>
                        </p>
                        <p className={styles.ga}>
                            <img src={bean} alt="备案"/>
                            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=50010502503990" rel="noreferrer"
                               target="_blank">渝公网安备50010502503990</a>
                        </p>
                        <p>
                            Copyright©2020-2024 重庆红海星科技有限公司版权所有
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HhxFooter;